import { render, staticRenderFns } from "./CreditUserDetailsDialog.vue?vue&type=template&id=085c60f7"
import script from "./CreditUserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./CreditUserDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports